const multipleCameraProperties = {
  camera_position: {
    type: 'object',
    properties: {
      lat: { type: ['string', 'number'] },
      lng: { type: ['string', 'number'] }
    },
    required: ['lat', 'lng']
  },
  subject_position: {
    type: 'object',
    properties: {
      lat: { type: ['string', 'number'] },
      lng: { type: ['string', 'number'] }
    },
    required: ['lat', 'lng']
  },
  locked: { type: ['string', 'boolean'] },
  display_ir_line: { type: ['string', 'boolean'] }
}
const multipleCameraRequirements = ['camera_position', 'subject_position']

function defaultPatternProperties(properties = {}, required = []) {
  return {
    '[0-9]+': {
      type: 'object',
      properties: {
        aov: { type: 'string' },
        ppf: { type: 'string' },
        tilt: { type: 'string' },
        unit: { type: 'string' },
        notes: { type: 'string' },
        title: { type: 'string' },
        width: { type: 'string' },
        distance: { type: 'string' },
        fov_mode: { type: 'string' },
        fov_image: { type: 'string' },
        resolution: { type: 'string' },
        imager_size: { type: 'string' },
        width_proxy: { type: 'string' },
        focal_length: { type: 'string' },
        fov_position: { type: 'string' },
        scene_height: { type: ['string', 'number'] },
        camera_height: { type: ['string', 'number'] },
        horizontal_aov: { type: 'string' },
        imager_size_text: { type: 'string' },
        camera_mode_enabled: { type: ['boolean', 'string'] },
        fov_image_is_user_selected: { type: ['boolean', 'string'] },
        display_ir_line: { type: ['boolean', 'string'] },
        selected_camera_configuration: {
          type: 'object',
          properties: { id: { type: ['string', 'integer'] } },
          required: ['id']
        },
        ...properties
      },
      required: ['resolution', 'imager_size', 'imager_size_text', 'focal_length', 'aov', 'distance', 'width', 'ppf', 'unit', 'fov_position', 'fov_image',
        'camera_mode_enabled', 'title', ...required]
    }
  }
}

export default function cameraProperties(project) {
  if (project['cameras']['0'] === undefined) throw new Error('Legacy project has no cameras')

  return Object.assign(
    {
      type: 'object',
      patternProperties: defaultPatternProperties(),
      additionalProperties: false
    },
    project['cameras']['0']['camera_position'] && {
      patternProperties: defaultPatternProperties(multipleCameraProperties, multipleCameraRequirements)
    }
  )
}



// WEBPACK FOOTER //
// ./src/schemas/legacy/helpers/cameraProperties.js